import { useQuery, useQueryClient, type UseQueryOptions } from 'react-query';

import type { IStageHistory, ILeadPropertyInterest } from 'src/services/api/lead-stage-history/types';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_LEADS_PATH } from 'src/services/api/leads/constants';

export type IGetLeadStageHistoryResponse = {
    stages: IStageHistory[];
    interests: ILeadPropertyInterest[];
};

export type ILeadStageHistoryData = {
    stages: IStageHistory[];
    interests: ILeadPropertyInterest[];
};

export const useLeadStageHistory = (
    leadUuid?: string,
    options?: UseQueryOptions<ILeadStageHistoryData, unknown>
) => {
    const queryClient = useQueryClient();

    return useQuery<ILeadStageHistoryData>(
        [queryKeys.leadStageHistory, leadUuid],
        async () => {
            if (!leadUuid) {
                // if called with no uuid, don't make the request
                return { stages: [], interests: [] };
            }
            const res = await apiClient(`${GET_LEADS_PATH}/${leadUuid}/stages/history`).json<IGetLeadStageHistoryResponse>();
            return { stages: res.stages, interests: res.interests ?? [] };
        },
        {
            enabled: !!leadUuid,
            onSuccess: (data) => {
                queryClient.setQueryData([queryKeys.leadStageHistory, leadUuid], data);
            },
            ...options,
        }
    );
};
